import { connect } from "react-redux";

import { showNotification } from "../../../../store/notification/actions";

import loadingComponent from "./loadable";

export default connect(null, { showNotification })(loadingComponent);
